import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

const Progress = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress 
        sx={{
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#4B49AC'
          }
        }}
      />
    </Box>
  );
}
export default Progress;
